<div ngModelGroup="dadosPessoais">
    <mat-toolbar class="titulopartes">Dados Iniciais do Familiar</mat-toolbar>

    <div fxLayout="row" fxFlexFill fxLayoutGap="20px">
        <div fxLayout="column" fxFlex>
            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                    <input matInput
                           [(ngModel)]="pessoaFisica.cpf"
                           name="cpf" (blur)="consultaPessoaFisica()"
                           placeholder="CPF:"
                           [textMask]="{mask: mascaraCpf}"
                           [cpfValidator]
                           required>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex fxFlexOffset="20px">
                    <input matInput maxlength="255" name="nome" placeholder="Nome Completo:"
                           [(ngModel)]="pessoaFisica.nome" required>
                </mat-form-field>

                <mat-form-field fxFlex>
                    <input matInput maxlength="255" name="nomeSocial" placeholder="Nome Social:"
                           [(ngModel)]="pessoaFisica.nomeSocial">
                </mat-form-field>

            </div>
        </div>
        <div fxLayout="column" fxLayoutGap="20px" style="text-align: end; flex-shrink: 0;">
            <button type="button" name="fotoPerfil" mat-raised-button class="botao" (click)="uploadFile.click()"
                    [style.background-image]="getBackground()">
                <mat-icon class="nao-foto"></mat-icon>
            </button>
            <input #uploadFile type="file" style="display:none;" (change)="fileChangeEvent($event)"/>
        </div>
    </div>

    <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field fxFlexOffset="20px" fxFlex="20">
            <input matInput name="dataNascimento"
                   [matDatepicker]="dataNascimento"
                   (input)="onMascaraDataInput($event)"
                   placeholder="Data de Nascimento"
                   [(ngModel)]="pessoaFisica.dataNascimento">
            <mat-datepicker-toggle matSuffix [for]="dataNascimento"></mat-datepicker-toggle>
            <mat-datepicker #dataNascimento></mat-datepicker>
        </mat-form-field>

        <combo-sexo fxFlex="15"
                    [selecionado]="pessoaFisica.sexo"
                    [obrigatorio]="false"
                    (valorChange)="onSexoChange($event)">
        </combo-sexo>

        <combo-raca fxFlex="15"
                    [selecionado]="pessoaFisica.raca"
                    [obrigatorio]="false"
                    (valorChange)="onRacaChange($event)">
        </combo-raca>

        <combo-estado-civil fxFlex="15"
                            [selecionado]="pessoaFisica.estadoCivil"
                            [obrigatorio]="false"
                            (valorChange)="onEstadoCivilChange($event)">
        </combo-estado-civil>

        <combo-grau-instrucao fxFlex
                              [selecionado]="pessoaFisica.grausInstrucao"
                              [obrigatorio]="false"
                              (valorChange)="onGrauInstrucaoChange($event)">
        </combo-grau-instrucao>
    </div>

    <div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
        <mat-form-field fxFlex="75" fxFlexOffset="20px">
            <input #campoCidade
                   matInput maxlength="200"
                   [(ngModel)]="pessoaFisica.cidadeNaturalidade"
                   name="cidadeNaturalidade"
                   placeholder="Cidade Naturalidade">
            <mat-hint align="end">{{ campoCidade.value.length }} / 200</mat-hint>
        </mat-form-field>

        <combo-uf fxFlex="25"
                  [selecionado]="pessoaFisica.ufNascimento"
                  [obrigatorio]="false"
                  (valorChange)="onUfChange($event)">
        </combo-uf>

    </div>

    <mat-toolbar class="titulopartes">Responsabilidade</mat-toolbar>
    <cadastrar-responsavel-familiar-aluno #cadastrarResponsavel
                                          [familiar]="familiar" [responsavel]="responsavel">
    </cadastrar-responsavel-familiar-aluno>

    <!-- ETAPA 1 - ENDEREÇO -->
    <cadastro-endereco [dadosEndereco]="pessoaFisica" [apresentaCopiarEndereco]="true"
                       (copiarEndereco)="copiarEnderecoBeneficiario()"></cadastro-endereco>

</div>
